var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.change)?_c('iframe',{attrs:{"id":"game","src":_vm.gameLink},on:{"load":_vm.load}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }